import FundingsContainer from "./FundingsContainer";
export default FundingsContainer;
